export const Popup = ({
  children,
  popupId,
  closable = true,
  className,
  bg = true,
  onClose = () => {},
}) => {
  const popup = useAppStore((state) => state.popup);
  const setPopup = useAppStore((state) => state.setPopup);

  const handleClose = () => {
    setPopup(null);
    onClose();
  };

  const show = popup == popupId;

  return (
    <AnimatePresence>
      {show && (
        <div className="full flex-center-col pointer-events-auto z-2">
          <div
            className={cn(
              //
              'full',
              bg && 'bg-black/50 backdrop-blur-sm'
            )}
            onClick={closable ? handleClose : undefined}
          />
          <div
            className={cn(
              'flex-center-col relative w-[30rem] p-3 font-bold',
              className
            )}
          >
            {children}
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};
